<template>
     <el-footer class="course_foot">
      <el-row>
        <el-col :span="4">
            <div class="course_foot_title">
                 郎哥编程课堂
             </div>
        </el-col>
      </el-row>
    </el-footer>
</template>
<script>
export default {
  name: 'FootRegion',
  props: {
    msg: String
  }
}
</script>
